"use client";

import { Splash } from "@/components/Splash/Splash";
import { useTheme } from "@/hooks/useTheme";
import { useRouters } from "@cloudspire/shared/hooks/useRouters";
import { FormattedMessage } from "react-intl";

export function DataHandlerInfiniteNoResult() {
  const { nextjsAccountRouter } = useRouters();

  const { theme } = useTheme();

  return (
    <Splash
      description={
        <FormattedMessage defaultMessage="Essayez d’élargir vos critères de recherche" />
      }
      src={nextjsAccountRouter.getUrl({
        id: "@account-v2/assets",
        parameters: {
          resource: `/assets/splashes/no-result/${theme}.svg`,
        },
      })}
      title={
        <FormattedMessage defaultMessage="Aucun résultat ne correspond à ces critères" />
      }
    />
  );
}
